import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { environment } from "src/environments/environment";

@Injectable({
  providedIn: "root",
})
export class StockService {
  constructor(private httpClient: HttpClient) {}

  getData() {
    return this.httpClient.get(environment.Localurl + "stock");
  }

  insertData(data) {
    return this.httpClient.post(environment.Localurl + "stock", data);
  }

  deleteData(id) {
    return this.httpClient.delete(environment.Localurl + "stock/" + id);
  }

  getOneStock(id) {
    return this.httpClient.get(
      environment.Localurl + "stock/findstockbyIdproduit/" + id
    );
  }

  updateData(id, data) {
    return this.httpClient.put(environment.Localurl + "stock/" + id, data);
  }
}
